import { schema } from 'normalizr';

const WAITING_SCHEMA = new schema.Entity('waitings', {}, { idAttribute: '@id' });
const WAITING_ITEM_SCHEMA = new schema.Entity('waiting_items', {}, { idAttribute: '@id' });

export default {
  Waiting: WAITING_SCHEMA,
  WaitingItem: WAITING_ITEM_SCHEMA
};
